namespace SP {
    export interface DeadlineInfo {
        sortingZoneId: string;
        name: string;
        deadline: string;
        focussed: boolean;
        prioritized: boolean;
        passed: boolean;
        orderCount: number;
    }
}